import { 
  FileText, 
  CircleDollarSign, 
  ClipboardCheck, 
  Banknote,
  BarChart,
  PieChart,
  Table,
  Clock,
  TrendingUp
} from "lucide-react";
import { WidgetDefinition } from "./widget-types";

// These static definitions are maintained for reference and as a fallback,
// but actual widget definitions are now stored in the database
export const USER_WIDGET_DEFINITIONS: WidgetDefinition[] = [
  {
    id: "total-contracts",
    title: "Total Contracts",
    description: "Shows the total number of contracts",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "user",
    queryName: "getUserContractStats",
    dataFields: ["totalContracts"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "active-contracts",
    title: "Active Contracts",
    description: "Shows the number of currently active contracts",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "user",
    queryName: "getUserContractStats",
    dataFields: ["activeContracts"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "expiring-contracts",
    title: "Expiring Contracts",
    description: "Shows contracts expiring in the next 30 days",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "user",
    queryName: "getUserContractStats",
    dataFields: ["expiringContracts"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "user-total-value",
    title: "Total Value",
    description: "Total value of all contracts in your default currency",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "user",
    queryName: "getUserContractValue",
    dataFields: ["totalValue", "defaultCurrency"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "contracts-timeline",
    title: "Contracts Timeline",
    description: "Chart showing contract creation over time",
    defaultSize: "large",
    chartType: "line",
    dashboardType: "user",
    queryName: "getContractsTimeline",
    dataFields: ["contractsTimeline"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "contracts-distribution",
    title: "Contracts Distribution",
    description: "Chart showing distribution of contracts by type",
    defaultSize: "medium",
    chartType: "pie",
    dashboardType: "user",
    queryName: "getContractsDistribution",
    dataFields: ["contractsByType"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "recent-contracts",
    title: "Recent Contracts",
    description: "List of recently created contracts",
    defaultSize: "medium",
    chartType: "table",
    dashboardType: "user",
    queryName: "getRecentContracts",
    dataFields: ["recentContracts"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "upcoming-expirations",
    title: "Upcoming Expirations",
    description: "List of contracts that are expiring soon",
    defaultSize: "medium",
    chartType: "table",
    dashboardType: "user",
    queryName: "getUpcomingExpirations",
    dataFields: ["upcomingExpirations"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "contract-costs-by-type",
    title: "Contract Costs by Type",
    description: "Monthly contract costs grouped by type",
    defaultSize: "medium",
    chartType: "bar",
    dashboardType: "user",
    queryName: "getContractCostsByType",
    dataFields: ["costsByType"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "financial-result",
    title: "Financial Result",
    description: "Shows total income minus costs and financial summary",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "user",
    queryName: "getUserFinancialResult",
    dataFields: ["result", "totalCost", "totalIncome", "defaultCurrency"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];
